export default __webpack_public_path__ + "static/media/offm1.bde769f8.png";